import { HttpSDK } from '@/api';
import { IFileMetaInfo } from '@/types';

export function useFilesApi() {
  async function getFileMetaInfo(key: string, isPublic = true) {
    const URL_DELIMITER = '/';
    const FILE_EXT_DELIMITER = '.';

    try {
      const [meta, url] = await Promise.all([
        HttpSDK.files.headObject(key, isPublic),
        HttpSDK.files.getDownloadUrl(key, isPublic),
      ]);

      const name = decodeURIComponent(url).split(URL_DELIMITER).pop() || '';
      const ext = name.split(FILE_EXT_DELIMITER).pop() || '';

      return {
        key,
        location: url,
        name,
        ext,
        size: meta.contentLength,
        mimeExt: meta.contentType,
        isPublic,
      } as IFileMetaInfo;
    } catch (e) {
      console.debug('Failed to get file URL or meta info!', e);
      throw e;
    }
  }

  async function uploadFile(file: File, path?: string) {
    const model = {
      name: file.name,
      type: file.type,
      file,
    };

    try {
      const fileKey = `${path}/${file.name}`;
      await HttpSDK.files.uploadFile({
        fileModel: model,
        prefix: `${path}/`,
        isPublic: true,
      });

      return HttpSDK.files.getDownloadUrl(fileKey, true);
    } catch (e) {
      console.debug('Failed to upload file!', e);
      throw e;
    }
  }

  return { getFileMetaInfo, uploadFile };
}
